(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery"], factory);
	else if(typeof exports === 'object')
		exports["module-behaviors"] = factory(require("jquery"));
	else
		root["module-behaviors"] = factory(root["jquery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    exports.retail = __webpack_require__(2);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /*global bd, gadgets */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    var $ = __webpack_require__(3);

	    // mock lp objects
	    //
	    var lpPortal = {
	        designMode: bd.designMode === 'true' };

	    var lpCoreUtils = {
	        parseBoolean: function parseBoolean(val) {
	            return typeof val === 'boolean' && val ||
	            typeof val === 'string' && /\s*true\s*/i.test(val) ||
	            typeof val === 'number' && val !== 0;
	        } };

	    var lpCoreBus = gadgets.pubsub;

	    //maps pubsub events to widget behavior tags
	    // [pubsub event] : [widget's behavior tag]
	    var showWidgetByEventMap = {
	        'launchpad-retail.viewAccounts': 'accounts',
	        'launchpad-retail.accountSelected': 'transactions',
	        'launchpad-retail.drawDownSelected': 'drawdown',
	        'launchpad-retail.portfolioSelected': 'wealth',
	        'launchpad-retail.requestMoneyTransfer': 'new-transfer',
	        'launchpad-retail.transactions.applyFilter': 'transactions',
	        'launchpad-retail.paymentOrderInitiated': 'review-transfers',
	        'launchpad-retail.openP2PPreferences': 'p2p-preferences',
	        'launchpad-retail.openP2PEnrollment': 'p2p-enrollment',
	        'launchpad-retail.openP2PTransactions': 'p2p-transactions',
	        'launchpad-retail.openCardManagement': 'card-management',
	        'launchpad-retail.viewProfile': 'profile',
	        'launchpad-retail.openEBillDashboard': 'billpay-dashboard',
	        'launchpad-retail.openRetailDashboard': 'retail-dashboard',
	        'launchpad-retail.ccPayment': 'cc-payment',
	        'launchpad-retail.requestTransferDetail': 'transfer-detail',
	        'launchpad-retail.requestPrepareTransfer': 'prepare-transfer',
	        'launchpad-retail.requestConfirmPayment': 'confirm-payment',
	        'launchpad-retail.requestCliqRegister': 'cliq-register',
	        'launchpad-retail.requestBulkPaymentDetails': 'bulk-payment-details',
	        'launchpad-retail.requestBulkPayment': 'bulk-payment',
	        'launchpad-retail.openRequestsEntitlement': 'requests-approval',
	        'launchpad-retail.openRequestDetails': 'request-details',
	        'launchpad-retail.signIn': 'sign-in',
	        'launchpad-retail.userVerification': 'user-verification',
	        'launchpad-retail.verification': 'verification',
	        'launchpad-retail.changePassword': 'change-password',
	        'launchpad-retail.termsAndConditions': 'terms-and-conditions' };


	    var showWidgetByHotKeyMap = {
	        // 'a': 'accounts',
	        // 't': 'transactions',
	        // 'n': 'new-transfer',
	        // 'c': 'address-book',
	        // 'r': 'review-transfers',
	        // 'l': 'places',
	        // 'p': 'p2p-transactions',
	        // 'e': 'p2p-enrollment',
	        // 'f': 'p2p-preferences',
	        // 'b': 'e-bill',
	        // 'x': 'external-accounts'
	    };

	    var defaultBehaviorEventName = 'launchpad-retail.behavior';

	    var showWidget = function showWidget(container, tag) {
	        container.loadByBehavior(tag, function () {
	            container.showByBehavior(tag);
	        });
	    };

	    //wires up the map above, the containe will ask the container to display widgets
	    var assignEvent = function assignEvent(container, event) {
	        var tag = showWidgetByEventMap[event];
	        lpCoreBus.subscribe(event, function (params) {
	            // Explicitly forbid behavior from
	            // processing a specific event.
	            if (params && params._noBehavior) {// eslint-disable-line no-underscore-dangle
	                return;
	            }

	            showWidget(container, tag || params.tag);
	        });
	    };


	    var initMappings = function initMappings(event) {

	        //ignore propagated events
	        if (this !== event.target) {
	            return;
	        }

	        var container = this;
	        var behaviorsInterfaceImplemented =
	        typeof container.loadByBehavior === 'function' && typeof container.showByBehavior === 'function';

	        //map retail specific events to container specific actions
	        if (behaviorsInterfaceImplemented) {
	            for (var pubsubEvent in showWidgetByEventMap) {
	                if (showWidgetByEventMap.hasOwnProperty(pubsubEvent)) {
	                    assignEvent(container, pubsubEvent);
	                }
	            }
	            assignEvent(container, defaultBehaviorEventName);

	            // bind keypress events
	            $(document).on('keypress.retail', function (e) {
	                //Please don't use e.keycode. It is not cross browser. jquery e.which is more reliable.
	                var key = String.fromCharCode(e.which).toLowerCase();
	                var behaviorTag = showWidgetByHotKeyMap[key];
	                var targetElementTagName = e.target.tagName.toLowerCase();
	                var targetElementContenteditable = e.target.getAttribute('contenteditable');
	                var validTarget = targetElementTagName !== 'input' && targetElementTagName !== 'textarea' && targetElementTagName !== 'select' && !targetElementContenteditable;

	                // matching behavior tag, target is not an input, not in portalmanager
	                if (behaviorTag && validTarget && !lpCoreUtils.parseBoolean(lpPortal.designMode)) {
	                    showWidget(container, behaviorTag);
	                }
	            });

	        } else {
	            console.warn('Attempting to map behaviors to an item which does implement the behaviors interface');
	        }
	    };

	    module.exports = {
	        showWidgetByEventMap: showWidgetByEventMap,
	        showWidgetByHotKeyMap: showWidgetByHotKeyMap,
	        RetailBehaviors: {
	            behaviors: {
	                'DOMNodeInsertedIntoDocument': initMappings } } };




	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js